import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconDashboard } from "@tabler/icons-react";
import { DashboardDef } from "./DashboardDef";

export const DashboardIcon = IconDashboard;
export const DashboardHelpText = '* Dashboard.';

export class Dashboard extends Entity<DashboardDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DashboardDef(), parentKeys);
        this.Form = import('./DashboardForm').then((module) => module.DashboardForm);
        this.Title = "Dashboard";
        this.HelpText = DashboardHelpText;
        this.Icon = DashboardIcon;
    }
}